import { render } from "./SustainabilityBlog.vue?vue&type=template&id=6f32b934&scoped=true"
import script from "./SustainabilityBlog.vue?vue&type=script&lang=js"
export * from "./SustainabilityBlog.vue?vue&type=script&lang=js"

import "./SustainabilityBlog.vue?vue&type=style&index=0&id=6f32b934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f32b934"]])

export default __exports__